import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {isTeammateNamespace} from '../../helpers/models/namespaceHelpers';
import {SearchTagSortsEnum} from '../../helpers/models/tagHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {SettingsTabsPagesEnum, SettingsTagsUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {dismissSettingsInfoBoxAction} from '../../store/data/localPreferences/localPreferencesActions';
import {getFindShouldDisplayInfoBox} from '../../store/data/localPreferences/localPreferencesSelectors';
import {nestTagsInsideNewParentTagAction} from '../../store/data/tags/tagBulkActions';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SettingsTagsList} from './settingsTagsList';

/*
 * Props.
 */

interface SettingsTagsListContainerProps {
  panelId: SettingsPanelId;
  tagsUrl: SettingsTagsUrl;
}

/*
 * Selectors.
 */

function getTagsUrl(_state: AppState, props: SettingsTagsListContainerProps) {
  return props.tagsUrl;
}

const getIsInArchivedView = createSelector(
  [getTagsUrl],
  (url) => url.tabPage === SettingsTabsPagesEnum.ARCHIVED,
);
const getIsInPersonalNamespace = createSelector([getTagsUrl], (url) => isTeammateNamespace(url.namespace));

const getInfoBoxId = createSelector([getIsInArchivedView, getTagsUrl], (isInArchivedView, tagsUrl) => {
  if (isInArchivedView) {
    return 'archived_tags';
  }

  return isTeammateNamespace(tagsUrl.namespace) ? 'individual_tags' : 'team_tags';
});

const getInitialTagSort = createSelector([getIsInArchivedView], (isInArchivedView) =>
  isInArchivedView ? SearchTagSortsEnum.NAME_ASC : SearchTagSortsEnum.PATH_ASC,
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsTagsListContainerProps>()(() => ({
  findShouldDisplayInfoBox: getFindShouldDisplayInfoBox,
  isInArchivedView: getIsInArchivedView,
  infoBoxId: getInfoBoxId,
  initialTagSort: getInitialTagSort,
  isInPersonalNamespace: getIsInPersonalNamespace,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  nestTagsInsideNewParentTag: nestTagsInsideNewParentTagAction,
  dismissSettingsInfoBox: dismissSettingsInfoBoxAction,
}));

export const SettingsTagsListContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsTagsList);
